// extracted by mini-css-extract-plugin
module.exports = {"order_conteiner":"order_order_conteiner__3DcZe"};